import React, { Component  } from 'react';
import {connect} from "react-redux";
import {setTextLayout, closeTour} from "../../actions";
import CurvedArrow from "../../components/CurvedArrow";

class TemplateLayouts extends Component {
  constructor(props) {
    super(props);
    this.handleClickHOC = this.handleClickHOC.bind(this);
  }

  handleClickHOC(i) {
    return () => {
      this.props.setTextLayout(i);
      this.props.closeTour(4);
    }
  }

  render() {
    return (
      <div className="t-container-sidebar-pane t-container-sidebar-pane-bottom">
        <div className="t-container-sidebar-content">
          <h3>レイアウトの選択</h3>

          {this.props.meishi.tour[4] && (
            <div className="t-tutorial t-tutorial-above">

              名刺のパターンを選択しましょう。
              {this.props.meishi.tour[4] && (
                <CurvedArrow className="arrow-blink" fromSelector=".t-tutorial-arrow" toSelector=".t-container-sticker-list" color="#1991EB" zIndex={1000} dynamicUpdate={true} />
              )}
              <div className="t-tutorial-arrow" />
            </div>
          )}

          {!this.props.meishi.tour[4] && (
            <div className="t-tutorial t-tutorial-above">
              <div className="t-tutorial-arrow-2" />
              右の枠にテキストを入力しましょう。
              {this.props.meishi.tour[5] && (
                <CurvedArrow className="arrow-blink" fromSelector=".t-tutorial-arrow-2" toSelector=".t-face-text-form" color="#1991EB" zIndex={1000} dynamicUpdate={true} />
              )}
            </div>
          )}

          <div className="t-container-sticker-list">
            {this.props.meishi.layouts.map((layout, i) => {
              let classNames = ["t-container-sticker-cell-full"];

              if (i === this.props.meishi.currentLayout) {
                classNames.push('active');
              }

              return (
                <div className={classNames.join(' ')} onClick={this.handleClickHOC(i)}>
                  <span
                    key={i}
                    className="t-container-sticker-cell"
                    style={{backgroundImage: 'url(' + window.tProjectGlobals.assetBaseUrl + 'img/' + layout.image + ')'}}
                  />
                  <div className="t-container-sticker-cell-full-right">
                    <strong>パターン{i + 1}</strong>
                    <div>
                      {layout.objects.map(object => (
                        <span>{object.label}</span>
                      ))}
                    </div>
                  </div>
                </div>

              );
            })}
          </div>


        </div>


      </div>
    );
  }
}

export default connect(f => f, {setTextLayout, closeTour})(TemplateLayouts);


// WEBPACK FOOTER //
// ./src/components/Face/TemplateLayouts.js